import styled from "styled-components";
import React from "react";

export const ProgressContainer = styled.div`
  width: ${(props) =>
          props.$context !== 'table' ? '100%' // 테이블 안에서는 항상 100%
                  : parseInt(props.$total) === 0 ? '0' : Math.min((props.$done / props.$total) * 100, 100) + '%'};
  height: ${(props) => (props.$angle ? '16px' : '14px')};
  border: ${(props) => (props.$angle ? '1px solid #cbc9c9' : '3px solid #cbc9c9')};
  border-radius: ${(props) => (props.$angle ? '' : '30px')};
  overflow: hidden;
  position: relative;
`;

export const ProgressBar = styled.div`
    height: 100%;
    background-color: var(--main-bg-color);
    width: ${(props) => (parseInt(props.$total) === 0 ? 0 : (props.$done / props.$total) * 100) + '%'};
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
`;

export const Strype = styled.div`
    position: absolute;
    border-radius: 30px 0 0 30px;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
            45deg, rgba(255, 255, 255, .15) 25%,
            transparent 25%, transparent 50%,
            rgba(255, 255, 255, .15) 50%,
            rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
    background-size: 40px 40px;
    transition: width .6s ease;
    animation: progressAnimationStrike 3s linear infinite;
`;

function ProgressBarBasic({ done, total, className, statics, angle, percent, context }) {
    return (
        <div>
            {statics && (
                <p className={'mb-[10px]'}>진행률 : {parseInt(total) === 0 ? 0 : ((done / total) * 100).toFixed(2)} %</p>
            )}
            {percent && (
                <p className={'absolute z-50 right-[20px]  mix-blend-difference text-white'}>
                    {parseInt(total) === 0 ? 0 : ((done / total) * 100).toFixed(2)} %
                </p>
            )}
            <ProgressContainer
                className="print-only-hidden"
                $angle={angle ? 'true' : 'undefined'}
                $context={context} // 추가된 context
            >
                <ProgressBar $done={done} $total={total} className={className}>
                    <Strype></Strype>
                </ProgressBar>
            </ProgressContainer>
        </div>
    );
}

export { ProgressBarBasic };
